/**
 * PC Grid Gallery – xexymix.hk
 * ─────────────────────────────────────────────────────
 * PC(≥990px): Flickity 슬라이더를 2열 그리드로 교체
 * 컬러칩 클릭 → 해당 컬러 이미지만 그리드에 표시
 * 모바일/태블릿(≤989px): 완전 비개입, 기존 Flickity 유지
 * ─────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  var BP = 990;

  /* ─────────────────────────────
   * 유틸
   * ───────────────────────────── */
  function isPC() { return window.innerWidth >= BP; }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function normUrl(url) {
    if (!url) return '';
    url = url.trim().split(' ')[0];
    if (url.startsWith('//')) url = 'https:' + url;
    return url;
  }

  /* ─────────────────────────────
   * 이미지 URL 해상도 변환
   * ───────────────────────────── */
  function toResolution(url, size) {
    var replaced = url.replace(/(_\d+x)(\.jpg|\.png|\.webp)/i, '_' + size + 'x$2');
    if (replaced !== url) return replaced;
    return url;
  }

  function getOriginal(src) {
    if (!src) return '';
    return src.replace(/_\d+x(?=\.(jpg|jpeg|png|webp))/i, '');
  }

  /* ─────────────────────────────
   * srcset에서 최대 해상도 URL 추출
   * ───────────────────────────── */
  function pickFromSrcset(srcset) {
    if (!srcset) return '';
    var best = { w: 0, url: '' };
    srcset.split(',').forEach(function (part) {
      var seg = part.trim().split(/\s+/);
      var url = seg[0] || '';
      var w   = seg[1] ? parseInt(seg[1], 10) : 0;
      if (w > best.w) best = { w: w, url: url };
    });
    return normUrl(best.url);
  }

  /* ─────────────────────────────
   * 슬라이더에서 컬러별 이미지 수집
   * ───────────────────────────── */
  function collectImagesByColor() {
  var slider = document.querySelector('.carousel.product__image-slider');
  if (!slider) return {};

  var map = {};
  slider.querySelectorAll('.carousel-cell[data-variant]').forEach(function (cell) {
    var color = cell.dataset.variant;
    if (!color) return;

    // ── 영상 처리 ──────────────────────────────
    var video = cell.querySelector('video source');
    if (video) {
      var videoSrc = video.getAttribute('src') || '';
      if (videoSrc) {
        if (!map[color]) map[color] = [];
        // { type:'video', src: url } 형태로 저장
        map[color].push({ type: 'video', src: videoSrc });
      }
      return;
    }

    // ── 이미지 처리 (기존) ──────────────────────
    var img = cell.querySelector('img');
    if (!img) return;

    var rawSrcset =
      img.getAttribute('data-flickity-lazyload-srcset') ||
      img.getAttribute('srcset') || '';

    var rawSrc =
      img.getAttribute('data-flickity-lazyload-src') ||
      img.getAttribute('src') || '';

    var baseUrl = rawSrcset ? pickFromSrcset(rawSrcset) : normUrl(rawSrc);
    if (!baseUrl) return;

    var gridUrl = toResolution(baseUrl, 1440);

    if (!map[color]) map[color] = [];
    if (map[color].findIndex(function(m){ return m.src === gridUrl; }) === -1) {
      map[color].push({ type: 'image', src: gridUrl });
    }
  });

  return map;
}

  /* ─────────────────────────────
   * 선택된 컬러명 파악
   * ───────────────────────────── */
  function getSelectedColor() {
    var checked = document.querySelector(
      'input[name="COLOR"]:checked, input[name="Color"]:checked, input[name="color"]:checked'
    );
    if (checked) return checked.value;

    var checkedLabel = document.querySelector('.renew-var-label.checked');
    if (checkedLabel) {
      return checkedLabel.getAttribute('value') ||
             checkedLabel.dataset.value || null;
    }

    var sel = document.querySelector(
      'select[name="COLOR"], select[name="Color"], select[name="color"]'
    );
    if (sel && sel.value) return sel.value;

    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (variantId) {
      var cell = document.querySelector(
        '.carousel.product__image-slider .carousel-cell[data-variant-id="' + variantId + '"]'
      );
      if (cell) return cell.dataset.variant;
    }

    var sel2 = document.querySelector(
      '.carousel.product__image-slider .is-selected[data-variant]'
    );
    if (sel2) return sel2.dataset.variant;

    var first = document.querySelector(
      '.carousel.product__image-slider .carousel-cell[data-variant]'
    );
    return first ? first.dataset.variant : null;
  }

  /* ─────────────────────────────
   * 그리드 DOM 생성 / 갱신
   * ───────────────────────────── */
  // 공통 영상 저장소
var _commonVideos = [];

function collectImagesByColor() {
  var slider = document.querySelector('.carousel.product__image-slider');
  if (!slider) return {};

  var map = {};
  _commonVideos = []; // 초기화

  slider.querySelectorAll('.carousel-cell[data-variant]').forEach(function (cell) {
    var color = cell.dataset.variant;
    if (!color) return;

    // ── 영상 처리: 컬러 무관하게 공통 배열에 저장 ──
    var videoSource = cell.querySelector('video source');
    if (videoSource) {
      var videoSrc = videoSource.getAttribute('src') || '';
      if (videoSrc && _commonVideos.indexOf(videoSrc) === -1) {
        _commonVideos.push(videoSrc);
      }
      return;
    }

    // ── 이미지 처리 (기존 로직) ──────────────────
    var img = cell.querySelector('img');
    if (!img) return;

    var rawSrcset =
      img.getAttribute('data-flickity-lazyload-srcset') ||
      img.getAttribute('srcset') || '';

    var rawSrc =
      img.getAttribute('data-flickity-lazyload-src') ||
      img.getAttribute('src') || '';

    var baseUrl = rawSrcset ? pickFromSrcset(rawSrcset) : normUrl(rawSrc);
    if (!baseUrl) return;

    var gridUrl = toResolution(baseUrl, 1440);

    if (!map[color]) map[color] = [];
    if (map[color].indexOf(gridUrl) === -1) {
      map[color].push(gridUrl);
    }
  });

  return map;
}

  var _imageMap = null;
  function getImageMap() {
    if (!_imageMap) _imageMap = collectImagesByColor();
    return _imageMap;
  }

 function buildGrid(colorName) {
  var wrapper = document.querySelector('.pc-grid-gallery-wrapper');
  if (!wrapper) return;

  var grid = wrapper.querySelector('.pc-grid-gallery');
  if (!grid) {
    grid = document.createElement('div');
    grid.className = 'pc-grid-gallery';
    wrapper.appendChild(grid);
  }

  var imgs = getImageMap()[colorName] || [];
  grid.classList.add('is-switching');

  setTimeout(function () {
    grid.innerHTML = '';

    // ── 이미지 렌더링 (기존) ──────────────────────
    imgs.forEach(function (src, idx) {
      var item = document.createElement('div');
      item.className = 'pc-grid-gallery__item';

      var img = document.createElement('img');
      img.alt     = colorName + ' ' + (idx + 1);
      img.loading = idx === 0 ? 'eager' : 'lazy';

      var original = getOriginal(src);
      var s1440    = toResolution(original, 1440);
      var s2048    = toResolution(original, 2048);

      img.src    = s1440;
      img.srcset = s1440 + ' 1x, ' + s2048 + ' 2x';
      img.sizes  = '(min-width: 1400px) 680px, (min-width: 990px) 60vw, 100vw';

      img.onload  = function () { item.classList.add('is-loaded'); img.classList.add('is-loaded'); };
      img.onerror = function () { item.classList.add('is-loaded'); };

      var lbSrc = toResolution(original, 2048);
      item.addEventListener('click', function () {
        openLightbox(lbSrc, colorName + ' – ' + (idx + 1));
      });

      item.appendChild(img);
      grid.appendChild(item);
    });

    // ── 공통 영상 렌더링 (모든 컬러에 노출) ────────
  _commonVideos.forEach(function (src) {
  var item = document.createElement('div');
  item.className = 'pc-grid-gallery__item is-loaded pc-grid-gallery__item--video'; // ← --video 추가

  var video = document.createElement('video');
  video.muted    = true;
  video.autoplay = true;
  video.loop     = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('preload', 'auto');
  // style은 CSS에서 처리하므로 제거

  var source = document.createElement('source');
  source.src  = src;
  source.type = 'video/mp4';
  video.appendChild(source);
  item.appendChild(video);
  grid.appendChild(item);
});

    grid.classList.remove('is-switching');

    // autoplay 강제 실행
    setTimeout(function () {
      grid.querySelectorAll('video').forEach(function (v) {
        v.muted = true;
        v.play().catch(function(){});
      });
    }, 300);

  }, 180);
}

  /* ─────────────────────────────
   * 라이트박스
   * ───────────────────────────── */
  var _lightbox = null;

  function getLightbox() {
    if (_lightbox) return _lightbox;
    _lightbox = document.createElement('div');
    _lightbox.className = 'pc-gallery-lightbox';
    _lightbox.innerHTML =
      '<button class="pc-gallery-lightbox__close" aria-label="Close">&#x2715;</button>' +
      '<img src="" alt="" />';

    _lightbox.querySelector('.pc-gallery-lightbox__close')
      .addEventListener('click', closeLightbox);
    _lightbox.addEventListener('click', function (e) {
      if (e.target === _lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
    document.body.appendChild(_lightbox);
    return _lightbox;
  }

  function openLightbox(src, alt) {
    var lb  = getLightbox();
    var img = lb.querySelector('img');
    // ✅ 라이트박스는 해상도 suffix 없는 원본 URL 사용
    img.src = getOriginal(src);
    img.alt = alt;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!_lightbox) return;
    _lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ─────────────────────────────
   * 컬러 변경 이벤트 바인딩
   * ───────────────────────────── */
  function bindColorEvents() {
    document.querySelectorAll(
      'input[name="COLOR"], input[name="Color"], input[name="color"]'
    ).forEach(function (inp) {
      inp.addEventListener('change', onColorChange);
    });

    document.querySelectorAll('.renew-var-label.color-swatch-wrapper').forEach(function (lbl) {
      lbl.addEventListener('click', function () {
        setTimeout(onColorChange, 60);
      });
    });

    document.querySelectorAll(
      'select[name="COLOR"], select[name="Color"], select[name="color"]'
    ).forEach(function (sel) {
      sel.addEventListener('change', onColorChange);
    });

    document.addEventListener('variant:change', onColorChange);

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.variantChange, onColorChange); } catch (e) {}
    }

    var hiddenId = document.querySelector('input[name="id"][form], input[name="id"].product-variant-id');
    if (hiddenId) {
      new MutationObserver(function () {
        setTimeout(onColorChange, 80);
      }).observe(hiddenId, { attributes: true, attributeFilter: ['value'] });
    }
  }

  function onColorChange() {
    if (!isPC()) return;
    var color = getSelectedColor();
    if (color) buildGrid(color);
  }

  /* ─────────────────────────────
   * 그리드 Wrapper 삽입
   * ───────────────────────────── */
  function injectWrapper() {
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;
    if (mediaWrapper.querySelector('.pc-grid-gallery-wrapper')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'pc-grid-gallery-wrapper';

    var slider = mediaWrapper.querySelector('.carousel.product__image-slider');
    if (slider) {
      mediaWrapper.insertBefore(wrapper, slider);
    } else {
      mediaWrapper.prepend(wrapper);
    }
  }

  /* ─────────────────────────────
   * 초기화 — PC에서만 실행
   * ───────────────────────────── */
  function init() {
    if (!isPC()) return;

    injectWrapper();

    var color = getSelectedColor();
    if (color) buildGrid(color);

    bindColorEvents();
  }

  var _lastWidth = window.innerWidth;
  window.addEventListener('resize', debounce(function () {
    var w = window.innerWidth;
    if (_lastWidth < BP && w >= BP) init();
    _lastWidth = w;
  }, 200));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 400);
    });
  } else {
    setTimeout(init, 400);
  }

})();
